module.exports = __webpack_public_path__ + "static/mtg-14ba5a68543bae17d742b5280c8318d9.jpg";